import Debug from 'debug'

export const info = Debug('app:info')
export const warn = Debug('app:warn')
export const debug = Debug('app:debug')
export const error = Debug('app:error')

export const log = info
